import { useToken } from '@chakra-ui/react';
import { gridConfig, MotionBox } from '@time-line/components/common';
import { useToastNotifiations } from 'hooks/useToastNotifications';
import { AnimatePresence } from 'motion/react';
import { useEffect, useState } from 'react';
import type { ToastNotification } from 'types/cms/ToastNotification';

import { Notification } from './Notification';

const { borderWidthClamp } = gridConfig;

export function ToastNotifications() {
  const { data: notifications } = useToastNotifiations();
  const [openNotifications, setOpenNotifications] = useState<
    ToastNotification[]
  >([]);

  useEffect(() => {
    const open = notifications
      ? notifications.reduce<ToastNotification[]>(
          (acc, notification) =>
            notification.isOpen ? [...acc, notification] : acc,
          [],
        )
      : [];
    setOpenNotifications(open);
  }, [notifications]);

  const transitionDuration = 0.3;
  const [gray50] = useToken('colors', ['gray.50']);

  const handleClose = (id: string) => {
    setOpenNotifications((prev) => prev.filter((item) => item._key !== id));
  };

  return (
    <AnimatePresence mode="wait">
      {openNotifications?.length && (
        <MotionBox
          display="flex"
          flexDir="column"
          gap={{ base: '5xs', sm: '4xs' }}
          p={borderWidthClamp}
          position="fixed"
          zIndex={6}
          bottom={0}
          right={0}
          width={{ base: '100%', sm: 420 }}
          alignItems="stretch"
          bgGradient={{
            base: `linear-gradient(0deg, ${gray50} 0px, rgba(252, 252, 250, 0.00) 100px)`,
            sm: `linear(346deg, ${gray50} 50px, rgba(252, 252, 250, 0.00) 100px)`,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: transitionDuration,
            delay: transitionDuration,
          }}
        >
          <AnimatePresence>
            {openNotifications?.map((banner) => (
              <MotionBox
                key={banner._key}
                layout
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: transitionDuration }}
              >
                <Notification notification={banner} onClose={handleClose} />
              </MotionBox>
            ))}
          </AnimatePresence>
        </MotionBox>
      )}
    </AnimatePresence>
  );
}
